import logo from './logo.svg';
import './App.css';
import { Landing } from './pages/Landing';
import { AIDemo } from './pages/AIDemo';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Contact } from './pages/Contact';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PageTitleUpdater from './components/PageTitleUpdater';
import { AnimatePresence } from 'framer-motion';
import Blog from './pages/Blog';
import  Blogs  from './pages/Blogs';
import Editor from './pages/BlogEditor';
import ArticlePage from './pages/ArticlePage';
import { ClerkProvider, RedirectToSignIn } from '@clerk/clerk-react';
import { SignedIn, SignedOut, SignInButton, UserButton } from '@clerk/clerk-react';
import EarnWithUs from './pages/EarnWithUs';
import MyBlogs from './pages/MyBlogs';
import PendingArticles from './pages/PendingArticles';
import PendingArticlePage from './pages/PendingArticlePage';

function App() {
  const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Publishable Key')
}
  return (
    <div className="div">
        <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <BrowserRouter>
      <PageTitleUpdater/>
      <Navbar/>
      <AnimatePresence exitBeforeEnter>
        <div style={{ minHeight: '80vh' }}>
      <Routes>
        <Route path="/" element={ <Landing/> } />
        
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/ai-demo" element={<AIDemo />} />
        <Route path="/blogs" element={<Blogs />} />
         <Route
        path="/my-blogs"
        element={
          <>
            <SignedIn>
              <MyBlogs />
            </SignedIn>
            <SignedOut>
              <Landing />
            </SignedOut>
          </>
        }
      /> 
       <Route
        path="/pending-blogs"
        element={
          <>
            <SignedIn>
              <PendingArticles />
            </SignedIn>
            <SignedOut>
              <Landing />
            </SignedOut>
          </>
        }
      /> 
      <Route
        path="/write"
        element={
          <>
            <SignedIn>
              <Editor />
            </SignedIn>
            <SignedOut>
              <Landing />
            </SignedOut>
          </>
        }
      />
        
        <Route path="/earn-with-us" element={ <EarnWithUs/> } />
         <Route path="/blog/:id" element={<ArticlePage />} />
         <Route path="/pending-blog/:id" element={<PendingArticlePage />} />
        </Routes>
        </div>
        </AnimatePresence>
    
    <Footer/>
    </BrowserRouter>
    </ClerkProvider>
    </div>
  );
}

export default App;